.container {
  flex: 1;
  display: flex;
  flex-direction: column;
  overflow: hidden;
  container-name: AI Chat;
}
